<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>维保设备列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="org-tree-layout">
            <swb-popover-org-tree :showMgmt="true" :showIncludeSubComs="true" :initIncludeSubComs="initIncludeSubComs" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :queryHandler="queryHandler" :popupHandler="popupHandler" :onConfigReady="onConfigReady"></swb-query-sort-area>
        </div>
        <div name="btn-bar" class="simple-row">
            <div class="right">
                <div class="swb-btn swb-btn-small swb-btn-primary" @click="setMaintProof">设置凭单模板</div>
                <div class="swb-btn swb-btn-small swb-btn-primary" id="setTag" v-if="checkActionPerm('setBizTag')" @click="setBizTag($event)">设置标签</div>
            </div>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect"
                          :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
        <swb-dt-popover ref="popoverRef" classes="popper-tabs">
            <swb-biz-tag-list-for-select :bizAspect="1" :selectIds="selectTagIds" ref="swb_biz_tag_list_for_select" @notity-bizTag-comfirm="doConfirm" @notity-bizTag-cancel="doCancel"></swb-biz-tag-list-for-select>
        </swb-dt-popover>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, DomSizeWatcher, Routes, getComnMerchantBizTag} from '../../app.vues'
    import {checkUserActionPerm} from '../index'
    import {getDefaultPageSizes} from '../../app.conf'
    import {openCurrContractSelectDlg, openShopDeviceSuitSelectDlg, openShopDeviceMintProofRelListDlg} from './selectDlg'
    import {devcMaintProofForSelectDlg} from '../devcMaint/selectDlg'
    import {openBigImgDlg} from '../comn/dialog'
    import {setAssetsGroupDevcFilter} from '../asset/selectDlg'
    import {loadAssetKindList, loadRetailerDevcGroupCascList, loadRetailerShopTagList, loadShopWarehouseList} from '../retailer/asset-comn'
    import {showShopDeviceInfo} from  '../devc/selectDlg';
    import {openBizDepartDlg} from '../orgStruct/selectDlg'

    import SwbShopDeviceStateManagement from './ShopDeviceStateManagement'
    Vue.regist(SwbShopDeviceStateManagement);

    import SwbShopDeviceSvcSubNoInfo from './ShopDeviceSvcSubNoInfo';
    Vue.regist(SwbShopDeviceSvcSubNoInfo);

    import SwbDeviceShopMaintainStatisList from '../statisWork/DeviceShopMaintainStatisList'
    Routes.add(SwbDeviceShopMaintainStatisList);

    import SwbShopDevicePatrolRecList from './ShopDevicePatrolRecList'
    Vue.regist(SwbShopDevicePatrolRecList);

    import SwbShopDeviceServcRecListDlg from './ShopDeviceServcRecListDlg'
    Vue.regist(SwbShopDeviceServcRecListDlg);

    //
    import userApi from '../../api/user'
    import devcApi from '../../api/devc'
    import shopDevcApi from '../../api/shopDevc'
    import shopStockApi from '../../api/shopStock'
    import assetApi from '../../api/asset'
    import retailerApi from '../../api/retailer'

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);
    //
    import SwbOrgTree from '../orgStruct/OrgTree';
    Vue.regist(SwbOrgTree);
    import SwbBizTagListForSelect from '../bizTag/BizTagListForSelect'
    Vue.regist(SwbBizTagListForSelect);
    //
    let bizTagObj = null;
    export default {
        name: 'swb-assert-run-repaire-list-main',
        path: '/asset/run/repaire/list/main',
        desc: '资产运行维护',
        data: function () {
            return {
                confKey: 'swb-assert-run-repaire-list-main',
                queryOnLoad: true,
                theTableHeight: 300,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 260,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                //
                enableSearch: true,
                isClickEvent: true,
                thisComId: null,
                treeCollapse: true,
                shopFlag: false,
                deviceId: null,
                tmpNo: null,
                //
                includeSubComs: false,
                initIncludeSubComs: false,
                comLevel: null,
                selectComId: null,
                currentComId: null,
                //
                tableState: [],
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                multipleSelection: [],
                //
                contractTypeEnum: null,
                acctEnterWayMap: [],
                devcClearCauseMap: [],
                seprPeriodStateMap: {},
                normalValue: null,
                failedValue: null,
                startValue: null,
                inactiveValue: null,
                outageValue: null,
                //
                bizTag: false,// 为了区分是设置标签还是标签管理
                selectTagId: null,
                selectTagIds: [], // 回显标签数据用
                scopeEntity: null,
                mgmtSmlAreaId: null
            }
        },
        created: function () {
            bizTagObj = getComnMerchantBizTag();
            let tmpNo = this.$route.query.tmpNo || null;
            if (!Utils.isNoB(tmpNo)) {
                this.initIncludeSubComs = true;
                this.includeSubComs = true;
            }
            //
            this.contractTypeEnum = getEnumMap('contractType', 'value2text');
            this.normalValue = getEnumInfoWith('deviceState', 'name', 'Normal').value;
            this.failedValue = getEnumInfoWith("deviceState", "name", "Failed").value;
            this.startValue = getEnumInfoWith('deviceUseState', 'name', 'Start').value;
            this.outageValue = getEnumInfoWith('deviceUseState', 'name', 'Outage').value;
            this.inactiveValue = getEnumInfoWith('deviceUseState', 'name', 'Inactive').value;
            this.acctEnterWayMap = getEnumMap("acctEnterWay", "value2text");
            this.devcClearCauseMap = getEnumMap("devcClearCause", "value2text");
            this.seprPeriodStateMap = getEnumMap("seprPeriodState", "value2text");
            this.getCurrentUserInfo();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.breadcrumb-layout, .org-tree-layout, [name="query-sort-block"], [name="btn-bar"]'));
            domSizeWatcher.start(500);
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onConfigReady(){
                let self = this;
                //
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                //
                loadAssetKindList(function (dataList) {
                    self.updateQueryModelField("assetKindId", dataList);
                });
                loadShopWarehouseList(self.selectComId, function (dataList) {
                    self.updateQueryModelField("warehouseId", dataList);
                });
                // 门店标签
                loadRetailerShopTagList(function (dataList) {
                    if ((!Utils.isNoB(self.shopFlag) && Utils.isTrue(self.shopFlag)) || dataList.length <= 0) {
                        query_model_ctrl.updateFields({
                            retailerShopTagId: {
                                hidden: true
                            }
                        });
                    } else {
                        self.updateQueryModelField("retailerShopTagId", dataList);
                    }
                });
                // 分类分组
                loadRetailerDevcGroupCascList(function (dataList) {
                    self.updateQueryModelField("devcGroupId", dataList);
                });
                //
                bizTagObj.loadSelectBizTagByBizAspect(1, function (dataList) {
                    self.updateQueryModelField("bizTag", dataList);
                });
                //
                let tmpNo = this.$route.query.tmpNo || null;
                if (!Utils.isNoB(tmpNo)) {
                    query_model_ctrl.updateFields({
                        tmpNo: {
                            value: tmpNo
                        }
                    });
                }
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if (itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'statusLabel': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if (row.wrntDueTime != null && new Date(row.currentTime).getTime() > new Date(row.wrntDueTime).getTime()) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">保外</a>';
                        }
                        if (row.wrntDueTime == null || new Date(row.currentTime).getTime() <= new Date(row.wrntDueTime).getTime()) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">保内</a>';
                        }
                        if (row.tagMissing) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">缺码</a>';
                        }
                        return domHtml;
                    },
                    'imageUrl': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.imageUrl != null && row.imageUrl != '') {
                            return '<a><img style="height: 36px;width: 36px" src="' + row.imageUrl + '"/></a>'
                        }
                    },
                    'indoubtFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue == 1) {
                            return '<span class="font-green">是</span>';
                        } else {
                            return '<span class="font-red">否</span>';
                        }
                    },
                    'suitMainFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue == 1) {
                            return '<span class="font-green">是</span>';
                        } else {
                            return '<span class="font-red">否</span>';
                        }
                    },
                    'specialFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return '<span class="font-green">是</span>';
                        } else {
                            return '<span class="font-red">否</span>';
                        }
                    },
                    'useState': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if (row.useState == self.inactiveValue) {
                            domHtml = '<span class="font-black">未启用</span>';
                        } else if (row.useState == self.outageValue) {
                            domHtml = '<span class="font-gold">已停用</span>';
                        } else if (row.useState == self.startValue) {
                            domHtml = '<span class="font-green">已启用</span>';
                        }
                        return domHtml;
                    },
                    'bizTag': function (row, colName, colValue, rowIndex, colConf) {
                        if (!Utils.isNoB(row.bizTag)) {
                            let bizTag = row.bizTag;
                            let tagIdList = [];
                            if (!Utils.isNoB(bizTag)) {
                                if (bizTag.indexOf("|") >= 0) {
                                    tagIdList = bizTag.split("|") || [];
                                } else {
                                    return '<span class="swb-tags swb-tags-success mr5">' + bizTag + '</span>';
                                }
                            }
                            let html = '';
                            for (let i = 0; i < tagIdList.length; i++) {
                                let tagId = tagIdList[i];
                                let tagName = bizTagObj.getBizTagNameById(tagId);
                                if (tagName != null) {
                                    html += '<span class="swb-tags swb-tags-success mr5">' + tagName + '</span>';
                                }
                            }
                            return html;
                        }
                    },
                    'state': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if (row.state == 0) {
                            domHtml = '<span class="font-green">正常</span>';
                        } else if (row.state == 1) {
                            domHtml = '<span class="font-red">有故障</span>';
                        } else if (row.state == 2) {
                            domHtml = '<span class="font-black">已报修</span>';
                        } else if (row.state == 3) {
                            domHtml = '<span class="font-black">维修中</span>';
                        }
                        return domHtml;
                    },
                    'locked': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return '<span class="font-green">是</span>';
                        } else {
                            return '<span class="font-red">否</span>';
                        }
                    },
                    'devcDefFlagName': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.devcDefId == -1) {
                            return '<span>未关联</span>';
                        } else {
                            return '<span>已关联</span>';
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        if (self.checkActionPerm('quick_act')) {
                            btnList.push({
                                name: 'quick_act',
                                text: '快捷操作'
                            })
                        }
                        if (self.checkActionPerm('view_servc_rec')) {
                            btnList.push({
                                name: 'view_servc_rec',
                                text: '服务记录'
                            })
                        }
                        if (self.checkActionPerm('view_detail')) {
                            btnList.push({
                                name: 'view_detail',
                                text: '设备详情'
                            })
                        }
                        if (self.checkActionPerm('patrol_rec')) {
                            btnList.push({
                                name: 'patrol_rec',
                                text: '内部巡查'
                            })
                        }
                        if (self.checkActionPerm('view_statistics')) {
                            btnList.push({
                                name: 'view_statistics',
                                text: '维保统计'
                            })
                        }
                        if (self.checkActionPerm('updateBizTag')) {
                            btnList.push({
                                name: 'updateBizTag',
                                text: '标签管理'
                            })
                        }
                        if (self.checkActionPerm('proof_rel')) {
                            btnList.push({
                                name: 'proof_rel',
                                text: '凭单管理'
                            })
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'imageUrl': function (row, colName, colValue, rowIndex, btnName) {
                        self.viewImage(colValue);
                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName, evnt) {
                        if (btnName == 'quick_act') {
                            self.stateManagement(row.tmpNo);
                        } else if (btnName == 'view_detail') {
                            self.showSvcSubNoInfo(row);
                        } else if (btnName == 'patrol_rec') {
                            self.toPatrolRec(row);
                        } else if (btnName == 'view_statistics') {
                            self.gotoDeviceShopMaintainStatisList(row.tmpNo);
                        } else if (btnName == 'view_servc_rec') {
                            self.showDeviceServcRec(row.id);
                        } else if (btnName == 'updateBizTag') {
                            // 设备维保情况
                            self.updateBizTag(null, row);
                        } else if (btnName == 'proof_rel'){
                            self.proofRel(row);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let data = result.data;
                        let scopeEntity = data.scopeEntity;
                        //
                        self.comLevel = scopeEntity.comLevel;
                        self.selectComId = scopeEntity.comId;
                        self.shopFlag = scopeEntity.shopFlag;
                        // 用于控制列表的操作
                        self.currentComId = scopeEntity.comId;
                        self.scopeEntity = scopeEntity;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            checkComCatChange: function (eventData) {
                this.mgmtSmlAreaId = null;
                if (Utils.isTrue(eventData.mgmtFlag)) {
                    let scopeEntity = this.scopeEntity;
                    this.comLevel = scopeEntity.comLevel;
                    this.selectComId = scopeEntity.comId;
                    this.includeSubComs = true;
                    this.mgmtSmlAreaId = eventData.id;
                } else {
                    this.comLevel = eventData.level;
                    this.selectComId = eventData.id;
                    this.includeSubComs = eventData.includeSubComs;
                }
                this.getShopDeviceSvcSubNoByComId();
                this.onConfigReady();
            },
            popupHandler: function (fieldCode, curValue, curText) {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                if (fieldCode == 'suitIds') {
                    let params = {};
                    //
                    params.thisComId = this.thisComId;
                    params.thisComLevel = this.thisComLevel;
                    params.includeSubComs = this.includeSubComs;
                    //
                    openShopDeviceSuitSelectDlg(params, function (suitList) {
                        let suitIdList = suitList.pluck("id");
                        let suitNameList = suitList.pluck("name");
                        //
                        let suitIds = suitIdList.join("_");
                        let suitNames = suitNameList.join("、");
                        //
                        let fieldInfo = {
                            suitIds: {
                                value: suitIds,
                                text: suitNames
                            }
                        };
                        query_model_ctrl.updateFields(fieldInfo);
                    });
                } else if (fieldCode == 'respblDepartId') {
                    openBizDepartDlg(this.thisComId, function (bizDepart) {
                        let fieldInfo = {
                            respblDepartId: {
                                value: bizDepart.id,
                                text: bizDepart.name
                            }
                        };
                        query_model_ctrl.updateFields(fieldInfo);
                    });
                } else if (fieldCode == 'applyUseDepartId') {
                    openBizDepartDlg(this.thisComId, function (bizDepart) {
                        let fieldInfo = {
                            applyUseDepartId: {
                                value: bizDepart.id,
                                text: bizDepart.name
                            }
                        };
                        query_model_ctrl.updateFields(fieldInfo);
                    });
                }
            },
            // 分页信息h/devc/cat/list
            checkActionPerm: function (action) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, null);
            },
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                //
                this.pageNumber = 1;
                this.getShopDeviceSvcSubNoByComId();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getShopDeviceSvcSubNoByComId();
            },
            //查询信息
            getShopDeviceSvcSubNoByComId: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.devcBizClolumType = getEnumInfoWith('devcBizClolumType', 'name', 'AssetRepaire').name;
                //
                filterItems.retailerComId = this.selectComId;
                filterItems.comLevel = this.comLevel || null;
                filterItems.includeSubComs = this.includeSubComs;
                filterItems.mgmtSmlAreaId = this.mgmtSmlAreaId;
                if (Utils.isNoB(filterItems.queryIncludeRented)) {
                    filterItems.queryIncludeRented = true;
                }
                if (self.noneBatchNo) {
                    filterItems.noneBatchNo = true;
                }
                let onlyImported = filterItems.onlyImported;
                if (!Utils.isNoB(onlyImported) && onlyImported) {
                    filterItems.imported = true;
                }
                let suitIds = filterItems.suitIds;
                if (!Utils.isNoB(suitIds)) {
                    filterItems.suitIdList = suitIds.split("_");
                }
                //
                let tmpNo = this.$route.query.tmpNo || null;
                if (!Utils.isNoB(tmpNo)) {
                    this.initIncludeSubComs = true;
                    this.includeSubComs = true;
                    filterItems.includeSubComs = true;
                    filterItems.tmpNo = tmpNo;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                devcApi.getShopDeviceListByFilter(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let data = result.data;
                        let shopDeviceSubNoList = data.rows || [];
                        let pagination = result.data.pagination;
                        self.renderTable(shopDeviceSubNoList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            // 状态管理
            stateManagement: function (tmpNo) {
                let self = this;
                let currentComId = self.currentComId;
                let theDlg = Vue.$showDialog({
                    title: "快捷操作",
                    width: 700,
                    height: 550,
                    okVisible: false,
                    cancelVisible: false,
                    showCloseBtn: true,
                    template: '<swb-shop-device-svcSubNo-state-management :tmpNo="tmpNo" :currentComId="currentComId" ref="shop_device_svcSubNo_edit"></swb-shop-device-svcSubNo-state-management>',
                    data: {
                        tmpNo: tmpNo,
                        currentComId: currentComId
                    },
                    onClosed: function (reason) {
                        self.getShopDeviceSvcSubNoByComId();
                    }
                });
            },
            toPatrolRec(row){
                let {href} = this.$router.resolve({
                    path: SwbShopDevicePatrolRecList.path,
                    query: {
                        tmpNo: row.tmpNo
                    },
                });
                window.open(href, '_blank');
            },
            // 查看详情
            showSvcSubNoInfo: function (row) {
                let showSingleTobObj = {
                    devcBaseInfoFalg: true,
                    repairInfoFalg: true,
                    manageInfoFalg: true,
                    useInfoFalg: true,
                    devcStatisInfoFalg: true,
                    srcInfoFalg: true,
                };
                showShopDeviceInfo(row.id, showSingleTobObj, '资产明细详情 - 查看');
            },
            //
            gotoDeviceShopMaintainStatisList: function (tmpNo) {
                let self = this;
                self.$router.push({
                    path: SwbDeviceShopMaintainStatisList.path,
                    query: {
                        tmpNo: tmpNo,
                    }
                })
            },
            /**
             * 批量设置凭单
             */
            setMaintProof: function () {
                let self = this;
                let multipleSelection = this.getTableSelection();
                let ids = multipleSelection.pluck("id");
                if (ids != null && ids.length > 0) {
                    let params = {
                        multiSelect: true,
                        appliedWorkType: 1 // 保养
                    };
                    devcMaintProofForSelectDlg(params, null, [], false, '凭单 - 选择', function (result) {
                        let postData = {};
                        postData.devcSubNoIdList = ids;
                        postData.proofIdList = result.pluck("id");
                        //
                        let theLoad = MsgBox.loading();
                        shopDevcApi.saveShopDeviceMaintProofRel(postData, function (result) {
                            theLoad.hide();
                            if (result.type === "info") {
                                MsgBox.success("设置成功！");
                                //
                                self.getShopDeviceSvcSubNoByComId();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    });
                } else {
                    MsgBox.warning("未选择数据！");
                }
            },
            viewImage: function (fileBrowseUrl) {
                openBigImgDlg(fileBrowseUrl);
            },
            //
            showDeviceServcRec(id){
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: "服务记录",
                    width: 1200,
                    height: 750,
                    okVisible: false,
                    showCloseBtn: true,
                    okClicked: false,
                    cancelText: '关闭',
                    template: '<div>' +
                    '<swb-shop-device-servc-rec-list-dlg :deviceSubNoId="deviceSubNoId" :toServcWork="toServcWork"></swb-shop-device-servc-rec-list-dlg>' +
                    '</div>',
                    data: {
                        deviceSubNoId: id
                    },
                    methods: {
                        toServcWork(routerObj){
                            theDlg.close();
                            self.$router.push(routerObj);
                        }
                    }
                });
            },
            // 设置标签
            setBizTag: function (event) {
                let multipleSelection = this.getTableSelection();
                let ids = multipleSelection.pluck("id");
                if (ids.length <= 0) {
                    MsgBox.warning("请选择资产信息");
                    return;
                }
                //
                this.bizTag = true;
                this.showPopoverRef(event);

            },
            showPopoverRef: function (event) {
                let popoverRef = this.$refs.popoverRef;
                if (popoverRef != null) {
                    popoverRef.doClear();
                }
                let curBtn = null;
                if (Utils.isNoB(event)) {
                    curBtn = document.getElementById('setTag');
                } else {
                    curBtn = event.currentTarget;
                }
                //
                popoverRef = this.$refs.popoverRef;
                popoverRef.bindToReferer(
                    curBtn, 'click', {
                        showNow: true,
                        placement: 'bottom-start'
                    }
                )
            },
            updateBizTag: function (event, row) {
                this.showPopoverRef(event);
                //
                let bizTag = row.bizTag;
                let tagIdList = [];
                if (!Utils.isNoB(bizTag)) {
                    bizTag = bizTag.substring(1, bizTag.length - 1);
                    let idList = bizTag.split("|") || [];
                    for (let i = 0; i < idList.length; i++) {
                        let id = idList[i];
                        tagIdList.push(parseInt(id));
                    }
                }
                this.selectTagIds = Utils.merge([], tagIdList);
                this.selectTagId = row.id;
            },
            doConfirm: function (data) {
                let self = this;
                let popoverRef = self.$refs.popoverRef;
                let tagIds = data.pluck("id") || [];
                //
                if (Utils.isTrue(self.bizTag)) {
                    let multipleSelection = this.getTableSelection();
                    let ids = multipleSelection.pluck("id");
                    if (tagIds.length <= 0) {
                        self.bizTag = false;
                        MsgBox.warning("请选择标签！");
                        return false;
                    }
                    let postData = {
                        ids: ids,
                        tagIds: tagIds,
                    };
                    devcApi.updateShopDeviceBizTagByIds(postData, function (result) {
                        if (result.type == "info") {
                            MsgBox.success("设置成功");
                            popoverRef.doClear();
                            let resultTable = self.$refs['result_table'];
                            resultTable.setInitChecked([]);
                            self.getShopDeviceSvcSubNoByComId();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    let postData = {
                        id: self.selectTagId,
                        tagIds: tagIds,
                    };
                    devcApi.updateShopDeviceBizTagById(postData, function (result) {
                        if (result.type == "info") {
                            MsgBox.success("设置成功");
                            popoverRef.doClear();
                            self.getShopDeviceSvcSubNoByComId();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
                self.bizTag = false;
                self.selectTagId = null;
            },
            doCancel: function () {
                let popoverRef = this.$refs.popoverRef;
                popoverRef.doHide();
                this.bizTag = false;
            },
            proofRel(row){
                openShopDeviceMintProofRelListDlg(row.id);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/AssetRunRepaire.vue